import { AlertDialog, AlertDialogAction, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from "./ui/alert-dialog";
import { Button } from "./ui/button";
import { Calendar, CheckCircle } from "lucide-react";

interface DecisionSuccessDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onDownloadCalendar: () => void;
  decisionTitle: string;
  reviewCount: number;
}

export function DecisionSuccessDialog({ 
  open, 
  onOpenChange, 
  onDownloadCalendar, 
  decisionTitle,
  reviewCount 
}: DecisionSuccessDialogProps) {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent className="max-w-md">
        <AlertDialogHeader className="text-center">
          <div className="flex justify-center mb-4">
            <CheckCircle className="h-12 w-12 text-green-500" />
          </div>
          <AlertDialogTitle>Decision Recorded!</AlertDialogTitle>
          <AlertDialogDescription className="space-y-3">
            <p>
              Your decision <strong>"{decisionTitle}"</strong> has been successfully recorded and will appear in your dashboard shortly.
            </p>
            {reviewCount > 0 && (
              <p>
                We've scheduled {reviewCount} review{reviewCount !== 1 ? 's' : ''} to help you track how this decision plays out over time.
              </p>
            )}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter className="flex-col space-y-2 sm:flex-row sm:space-y-0 sm:space-x-2">
          {reviewCount > 0 && (
            <Button
              variant="outline"
              onClick={onDownloadCalendar}
              className="w-full sm:w-auto"
            >
              <Calendar className="h-4 w-4 mr-2" />
              Add to Calendar
            </Button>
          )}
          <AlertDialogAction className="w-full sm:w-auto">
            Got it!
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}